module.exports = __webpack_public_path__ + "img/1024.382fb446.png";